import { Box, Button, Container, Grid, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ImageUploader, SubheaderV2 } from 'components';
import CourseForm from 'features/courses/CourseForm';
import { useAlerts, useCourses, useUploadFileInMemory } from 'hooks';
import { validateCourse } from 'validations/courses';

const CourseEdit = ({ ...props }) => {
	const navigate = useNavigate();
	const { id } = useParams();
	const {
		course,
		handleChange,
		updateCourse,
		findCourse,
		uploadFile,
		deleteFile
	} = useCourses({ id: id });
	const { showAlertSuccess, showAlertError } = useAlerts();
	const { memoryFile } = useUploadFileInMemory();

	const handleSaveClick = async () => {
		const valid = validateCourse(course);
		if (valid.isValid) {
			delete course.difficulty;
			await updateCourse(course);
			showAlertSuccess('Course has been updated');
			navigate(`/courses/${id}`);
		} else {
			valid.messages.map((m) => showAlertError(m));
		}
	};

	const handleUpload = async (file, type) => {
		await uploadFile(file, type);
		findCourse(id);
	};

	const handleDelete = async (type) => {
		await deleteFile(type);
		findCourse(id);
	};

	useEffect(() => {
		if (id) findCourse(id);
	}, []);

	return (
		<>
			<SubheaderV2
				title="Edit Course"
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Update Course
					</Button>
				]}
			/>
			<Container>
				<Box p={4}>
					<CourseForm course={course} handleChange={handleChange} />
				</Box>
				<Box px={4}>
					<Grid container spacing={1}>
						<Grid item md={6} xs={12}>
							<Typography variant="body2" color="textSecondary">
								{'Course Image'}
							</Typography>
							<ImageUploader
								label={`Upload Image`}
								imageUrl={
									course?.image_url ||
									(memoryFile && memoryFile?.image_url?.url)
								}
								handleUpload={(file) => handleUpload(file, 'image_url')}
								handleDelete={() => handleDelete('image_url')}
							/>
						</Grid>
					</Grid>
				</Box>
			</Container>
		</>
	);
};

export default CourseEdit;
